<template>
  <div
    :key="member.id"
    class="d-flex align-items-center px-2 py-1"
    @click="modalOpener ? modalOpener() : () => {}"
  >
    <subscriber-avatar
      small
      with-profile
      :subscriber="member"
      class="mr-2"
      @init="cb => (modalOpener = cb)"
    />

    <div class="name">
      {{ member.name }}
    </div>
    <div class="d-flex align-items-center ml-auto">
      <v-button
        v-if="canStartMessage"
        ghost
        round
        :is-loading="isNavigating"
        class="message-button"
        @click.stop="startChat"
      >
        <v-icon icon="message" class="text-grey-60" />
      </v-button>

      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"

import store from "@/store"

import { canStartMessage } from "@/lib/messages-utils"

export default {
  components: {
    SubscriberAvatar: () => import("@/components/SubscriberAvatar")
  },

  props: {
    member: { type: Object, required: true }
  },

  computed: {
    canStartMessage() {
      return canStartMessage(this.member, store)
    }
  },

  data() {
    return {
      isNavigating: false,
      modalOpener: () => {}
    }
  },

  methods: {
    ...mapActions("messages", ["resolveThread"]),

    startChat() {
      this.isNavigating = true

      this.resolveThread({
        subscriberIds: [this.member.id],
        router: this.$router
      }).finally(() => (this.isNavigating = false))
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";
.name {
  font-weight: $font-weight--semi-bold;
}
</style>
